/**
 *
 * @param isMobile
 * @param mobileHeight
 * @param nonMobileHeight
 */
export const getInitialSlideHeight = (
    isMobile: boolean,
    mobileHeight: string,
    nonMobileHeight: string
): string => (isMobile ? mobileHeight : nonMobileHeight);
